import React, { useEffect, useState } from 'react';
import { Button, Modal, TimePicker } from 'antd';
import './reccuring.css';
import config from '../../config.json'
import dayjs from 'dayjs';
import CalendarAPI from '../../common/util/CalendarAPI';
import { Col, PopoverBody, PopoverHeader, Row, UncontrolledPopover, UncontrolledTooltip } from 'reactstrap';
import { DatePicker } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import UserService from '../../common/util/UserService';
import moment from 'moment';
import Loader from '../../common/loader';
import { convertToUSTime, modifyTimezoneString } from '../HR/TimeClock/Util';


const GlobalRecurring = ({ start, tillDate, onClose, onSave, obj, action, id, users, refreshRecurringData,repeatObj,setRepeatObj }) => {
    const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    let repeatEventObject = {
        OnDay: new Date().getDate(),
        OnMonth: "OnDay",
        EventDate: new Date(Date.now()),
        MonthStep: "1",
        MonthDay: weekdays[new Date().getDay()],
        Time: new Date(),
        DailyIntervalCount: "1",
        WhichMonth: `${new Date().getMonth() + 1}`,
        EndBy: "Never",
        Repeat: "Daily",
        DailyInterval: "Every",
        WeeklyDay: `${dayjs().format("dddd")}`,
    }

    // const [repeatObj, setRepeatObj] = useState({ ...repeatEventObject });
    // useEffect(e=>{
    //     if(repeatObj){
    //         setRepeatObj(repeatObj)
    //     }else{
    //         setRepeatObj(repeatEventObject);
    //     }
    // },[value])
    // useEffect(e=>{
    //     onChange && onChange(repeatObj);
    // },[repeatObj])
    const userinfo = JSON.parse(localStorage.getItem('userinfo'))
    //const [repeatObj, setRepeatObj] = useState({OnDay:new Date().getDate(),OnMonth:'OnDay',EventDate:new Date(Date.now()), MonthStep: '1', MonthDay: weekdays[new Date().getDay()], DailyIntervalCount: '1', WhichMonth: `${new Date().getMonth() + 1}`, EndBy: 'Never', Repeat: 'Daily', DailyInterval: 'Every', WeeklyDay: `${dayjs().format('dddd')}` })

    const [selectedUser, setSelectedUser] = useState([{ role: localStorage.getItem('Role'), photo: localStorage.getItem('ProfilePhoto'), email: userinfo?.email_id, name: userinfo?.first_name + " " + userinfo?.last_name, zuid: localStorage.getItem('ZUID') }])
    const [dueDatePopUp, setDueDatePopUp] = useState(false);
    const [notifyMePopUp, setNotifyMePopUp] = useState(false);
    const [closeAssigneePopup, setCloseAssigneePopup] = useState(false);
    const [loading, setLoading] = useState(false);


    const convertWeeklyDayTOShortDay = (days) => {
        weekdays.forEach((one) => {
            if (days.includes(one.slice(0, 2).toUpperCase())) {
                days = days.replaceAll(one.slice(0, 2).toUpperCase(), one);
            }
        })
        return days;
    }

    const handleOnChange = (e) => {
        if (e.currentTarget.value < 1 && e.currentTarget.name != "MonthStep") {
            e.preventDefault();
            return
        }
        const obj = { ...repeatObj };
        obj[e.currentTarget.name] = e.currentTarget.value;
        setRepeatObj(obj);
    }

    const getHourlyContent = () => {
        return <>
            <div className='form-group'>
                <div className='row'>
                    <div className='col-6'>
                        <div className="row">
                            <div className="col-4 d-flex align-items-center">
                                <input type='radio' disabled={action == "editview" ? true : false} checked={repeatObj?.DailyInterval == 'Every'} value={'Every'} onChange={handleOnChange} name='DailyInterval' />&nbsp;&nbsp;<span>Every</span>
                            </div>
                            <div className="col-4 pl-0">
                                <input name='DailyIntervalCount' disabled={repeatObj?.DailyInterval == 'Every' && action != "editview" ? false : true} value={repeatObj?.DailyIntervalCount} onChange={handleOnChange} className="form-control  form-control-sm" type='text' />
                            </div>
                            <div className="col-4 p-0  d-flex align-items-center">
                                <span className='w-100'>day(s) once</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-4 d-flex align-items-center'>
                        <input type='radio' checked={repeatObj?.DailyInterval == 'WeekDay'}
                            disabled={action == "editview" ? true : false}
                            onChange={(e) => {
                                handleOnChange(e)
                            }} value={'WeekDay'} name='DailyInterval' />&nbsp;&nbsp;<span>Weekday only</span>
                    </div>

                </div>

            </div>
            {/* <div className='form-group'>
                <div className='row'>
                    <div className='col'>
                        <input type='radio' checked={repeatObj?.DailyInterval == 'WeekDay'} onChange={(e) => {

                            handleOnChange(e)
                        }} value={'WeekDay'} name='DailyInterval' />&nbsp;&nbsp;<span>Weekday only</span>
                    </div>
                </div>

            </div> */}
        </>
    }
    const getDailyContent = () => {
        return <>
            <div className='form-group'>
                <div className='row'>
                    <div className='col-6'>
                        <div className="row">
                            <div className="col-4 d-flex align-items-center">
                                <input type='radio' disabled={action == "editview" ? true : false} checked={repeatObj?.DailyInterval == 'Every'} value={'Every'} onChange={handleOnChange} name='DailyInterval' />&nbsp;&nbsp;<span>Every</span>
                            </div>
                            <div className="col-4 pl-0">
                                <input name='DailyIntervalCount' disabled={repeatObj?.DailyInterval == 'Every' && action != "editview" ? false : true} value={repeatObj?.DailyIntervalCount} onChange={handleOnChange} className="form-control  form-control-sm" type='text' />
                            </div>
                            <div className="col-4 p-0  d-flex align-items-center">
                                <span className='w-100'>day(s) once</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-4 d-flex align-items-center'>
                        <input type='radio' checked={repeatObj?.DailyInterval == 'WeekDay'}
                            disabled={action == "editview" ? true : false}
                            onChange={(e) => {

                                handleOnChange(e)
                            }} value={'WeekDay'} name='DailyInterval' />&nbsp;&nbsp;<span>Weekday only</span>
                    </div>

                </div>

            </div>
            {/* <div className='form-group'>
                <div className='row'>
                    <div className='col'>
                        <input type='radio' checked={repeatObj?.DailyInterval == 'WeekDay'} onChange={(e) => {

                            handleOnChange(e)
                        }} value={'WeekDay'} name='DailyInterval' />&nbsp;&nbsp;<span>Weekday only</span>
                    </div>
                </div>

            </div> */}
        </>
    }

    const getWeeklyContent = () => {
        return <>
            <div className='form-group'>
                <div className='row'>
                    <div className='col-6 '>
                        <div className="row">
                            <div className="col-4 d-flex align-items-center">
                                {/* <input type='radio' checked={repeatObj?.DailyInterval=='Every'} value={'Every'} onChange={handleOnChange} name='DailyInterval' />&nbsp;&nbsp; */}
                                <span>Every</span>
                            </div>
                            <div className="col-4 pl-0">
                                <input disabled={action == "editview" ? true : false} name='DailyIntervalCount' onChange={handleOnChange} className="form-control  form-control-sm" type='text' />
                            </div>
                            <div className="col-4 p-0 d-flex align-items-center">
                                <span className='w-100'>week(s) once</span>
                            </div>
                        </div>

                    </div>
                    <div className='col'>

                    </div>

                </div>

            </div>
            <div className='form-group'>
                <div className='row'>
                    <div className='col weekly_tabs'>
                        {weekdays.map(day => {
                            return <span onClick={(e) => {
                                if (action == "editview") {
                                    e.preventDefault();
                                    return
                                }
                                let obj = { ...repeatObj };
                                if (obj.WeeklyDay.includes(day)) {
                                    obj.WeeklyDay = obj.WeeklyDay.replaceAll(day + ',', '');
                                    obj.WeeklyDay = obj.WeeklyDay.replaceAll(day, '');
                                } else {
                                    obj.WeeklyDay = obj.WeeklyDay + ',' + day;
                                }
                                setRepeatObj(obj);
                            }} style={repeatObj?.WeeklyDay && repeatObj?.WeeklyDay.includes(day) ? { borderColor: '#007bff', backgroundColor: '#007bff', color: 'white' } : {}}>{day.charAt(0)}</span>
                        })}
                    </div>
                </div>

            </div>
        </>
    }

    const getMonthlyContent = () => {
        return <>
            <div className='form-group'>
                <div className='row'>
                    <div className='col-6 '>
                        <div className="row">
                            <div className="col-4 d-flex align-items-center">
                                <span>Every</span>
                            </div>
                            <div className="col-4 pl-0">
                                <input disabled={action == "editview" ? true : false} value={repeatObj?.DailyIntervalCount ? repeatObj?.DailyIntervalCount : ''} name='DailyIntervalCount' onChange={handleOnChange} className="form-control  form-control-sm" type='text' />
                            </div>
                            <div className="col-4 p-0 d-flex align-items-center">
                                <span className='w-100'>month(s) once</span>
                            </div>
                        </div>
                    </div>
                    <div className='col'>
                    </div>
                </div>
            </div>
            <div className='form-group'>
                <div className='row'>
                    <div className='col-8'>
                        <div className="row">
                            <div className="col-4 d-flex align-items-center">
                                <input type='radio' checked={repeatObj?.OnMonth == 'OnDay'} onChange={(e) => {
                                    if (action == "editview") {
                                        return
                                    }
                                    handleOnChange(e)
                                }} value={'OnDay'} name='OnMonth' />&nbsp;&nbsp;<span>On day</span>
                            </div>
                            <div className="col pl-1">
                                <input value={repeatObj?.OnDay ? repeatObj?.OnDay : ''} disabled={!(repeatObj?.OnMonth == 'OnDay') || (action == "editview")} name='OnDay' onChange={handleOnChange} className="form-control  form-control-sm" type='text' />
                            </div>
                        </div>

                    </div>
                    <div className='col'>

                    </div>

                </div>

            </div>
            <div className='form-group'>
                <div className='row'>
                    <div className='col-8'>
                        <div className="row">
                            <div className="col-4 d-flex align-items-center">
                                <input type='radio' checked={repeatObj?.OnMonth == 'OnThe'} onChange={(e) => {
                                    if (action == "editview") {
                                        return
                                    }
                                    handleOnChange(e)
                                }} value={'OnThe'} name='OnMonth' />&nbsp;&nbsp;<span>On the</span>
                            </div>
                            <div className="col-4 pl-1">
                                <select value={repeatObj?.MonthStep ? repeatObj?.MonthStep : ''} name='MonthStep' disabled={!(repeatObj?.OnMonth == 'OnThe') || (action == "editview")} onChange={handleOnChange} className='form-control form-control-sm'>
                                    <option value={'1'}>First</option>
                                    <option value={'2'}>Second</option>
                                    <option value={'3'}>Third</option>
                                    <option value={'4'}>Fourth</option>
                                    <option value={'-1'}>Last</option>
                                </select>
                            </div>
                            <div className="col-4 pl-1">
                                <select value={repeatObj?.MonthDay ? repeatObj?.MonthDay : ''} name='MonthDay' disabled={!(repeatObj?.OnMonth == 'OnThe') || (action == "editview")} onChange={handleOnChange} className='form-control form-control-sm'>
                                    {weekdays.map((day) => {
                                        return <option value={day}>{day}</option>
                                    })}
                                </select>
                            </div>
                        </div>



                    </div>
                </div>

            </div>

        </>
    }

    const getYearlyContent = () => {
        return (
            <>
                <div className="form-group">
                    <div className="row">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-4 d-flex align-items-center">
                                    <span>Every</span>
                                </div>
                                <div className="col pl-0">
                                    <select
                                        name="WhichMonth"
                                        disabled={action == "editview"}
                                        value={repeatObj?.WhichMonth ? repeatObj?.WhichMonth : ""}
                                        onChange={handleOnChange}
                                        className="form-control form-control-sm"
                                    >
                                        {config.month.map((month) => {
                                            return (
                                                <option value={month.number}>{month.name}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col"></div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="row">
                        <div className="col-8">
                            <div className="row">
                                <div className="col-4 d-flex align-items-center">
                                    <input
                                        type="radio"
                                        checked={repeatObj?.OnMonth == "OnDay"}
                                        onChange={(e) => {
                                            if (action == "editview") {
                                                return;
                                            }
                                            handleOnChange(e);
                                        }}
                                        value={"OnDay"}
                                        name="OnMonth"
                                    />
                                    &nbsp;&nbsp;<span>On day</span>
                                </div>
                                <div className="col pl-1">
                                    <input
                                        disabled={
                                            !(repeatObj?.OnMonth == "OnDay") || action == "editview"
                                        }
                                        value={repeatObj?.OnDay ? repeatObj?.OnDay : ""}
                                        name="OnDay"
                                        onChange={handleOnChange}
                                        className="form-control  form-control-sm"
                                        type="text"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col"></div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="row">
                        <div className="col-8 ">
                            <div className="row">
                                <div className="col-4 d-flex align-items-center">
                                    <input
                                        type="radio"
                                        checked={repeatObj?.OnMonth == "OnThe"}
                                        onChange={(e) => {
                                            if (action == "editview") {
                                                return;
                                            }
                                            handleOnChange(e);
                                        }}
                                        value={"OnThe"}
                                        name="OnMonth"
                                    />
                                    &nbsp;&nbsp;<span>On the</span>
                                </div>
                                <div className="col-4 pl-1">
                                    <select
                                        value={repeatObj?.MonthStep ? repeatObj?.MonthStep : ""}
                                        name="MonthStep"
                                        disabled={
                                            !(repeatObj?.OnMonth == "OnThe") || action == "editview"
                                        }
                                        onChange={handleOnChange}
                                        className="form-control form-control-sm"
                                    >
                                        <option value={"1"}>First</option>
                                        <option value={"2"}>Second</option>
                                        <option value={"3"}>Third</option>
                                        <option value={"4"}>Fourth</option>
                                        <option value={"-1"}>Last</option>
                                    </select>
                                </div>
                                <div className="col-4 pl-1">
                                    <select
                                        value={repeatObj?.MonthDay ? repeatObj?.MonthDay : ""}
                                        name="MonthDay"
                                        disabled={
                                            !(repeatObj?.OnMonth == "OnThe") || action == "editview"
                                        }
                                        onChange={handleOnChange}
                                        className="form-control form-control-sm"
                                    >
                                        {weekdays.map((day) => {
                                            return <option value={day}>{day}</option>;
                                        })}
                                        {/* <option>Monday</option>
                                    <option>Tuesday</option>
                                    <option>Wenesday</option>
                                    <option>Thursday</option>
                                    <option>Friday</option>
                                    <option>Saturday</option>
                                    <option>Sunday</option> */}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };
    const getContentByRpeat = (type) => {
        switch (type) {
            case 'Hourly':
                return getHourlyContent()
            case 'Daily':
                return getDailyContent()
            case 'Weekly':
                return getWeeklyContent()
            case 'Monthly':
                return getMonthlyContent()
            case 'Yearly':
                return getYearlyContent()
            default:
                return <></>
        }
    }

    const steps = { 1: 'First', '2': 'Second', '3': 'Third', '4': 'Fourth', '-1': 'Last' }

    const getPlaceholderText = () => {
        let text = ''
        if (repeatObj?.Repeat == 'Daily') {
            if (repeatObj?.DailyInterval == 'Every') {
                text = `Every ${repeatObj?.DailyIntervalCount} day `
            }
            if (repeatObj?.DailyInterval == 'WeekDay') {
                text = `Every Weekday `
            }

        }
        if (repeatObj?.Repeat == 'Weekly') {
            text = `Every ${repeatObj?.DailyIntervalCount} Week on ${repeatObj?.WeeklyDay} `
        }
        if (repeatObj?.Repeat == 'Monthly') {
            if (repeatObj?.OnMonth == 'OnDay') {
                text = `Every ${repeatObj?.DailyIntervalCount} month on day ${repeatObj?.OnDay} `
            }
            if (repeatObj?.OnMonth == 'OnThe') {
                text = `Every ${repeatObj?.DailyIntervalCount} month on  ${steps[repeatObj?.MonthStep]}  ${repeatObj?.MonthDay} `
            }

        }
        if (repeatObj?.Repeat == 'Yearly') {
            if (repeatObj?.OnMonth == 'OnDay') {
                let whichMonth = ''
                let monthFilter = config.month.filter((one) => one.number == repeatObj?.WhichMonth);
                if (monthFilter.length > 0) {
                    whichMonth = monthFilter[0].abbreviation
                }
                text = `Every ${whichMonth} on day ${repeatObj?.OnDay} `
            }
            if (repeatObj?.OnMonth == 'OnThe') {
                text = `Every year on   ${steps[repeatObj?.MonthStep]}  ${repeatObj?.MonthDay}  of  ${config.month.some(one => one.number == repeatObj?.WhichMonth) ? config.month.filter(one => one.number == repeatObj?.WhichMonth)[0].name : " "} `
            }

        }
        if (repeatObj?.EndBy == 'ByCount') {
            text = text + `For ${repeatObj?.EndByValue} times `
        }
        if (repeatObj?.EndBy == 'ByDate') {
            text = text + `Until ${dayjs(repeatObj?.EndByValue).format('MMM DD YYYY')}`
        }

        return text;
    }

    const removeAssignee = (user) => {
        let selected = [...selectedUser]
        selected = selected.filter(obj => obj.zuid !== user.zuid);
        setSelectedUser(selected);
    }

    const fetchPhotoFromLocalstorage = (photo, name, user) => {
        if (photo === null || photo === "") {
            return (
                <div className='user-img-icon common_reminder_box'>
                    {selectedUser.length > 1 ? <FontAwesomeIcon icon={faTimes} onClick={() => removeAssignee(user)} className='remove-user' /> : <></>}
                    <div className='no-image-user'
                        type="button" id="reminder-pop-user" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        onClick={() => {
                            setDueDatePopUp(false);
                            setNotifyMePopUp(false);
                            setCloseAssigneePopup(!closeAssigneePopup);
                        }}
                    >{name ? name.charAt(0) : ''}</div>
                </div>
            )
        }


        else {
            return (
                <div className='user-img-icon common_reminder_box'>
                    {selectedUser.length > 1 ? <FontAwesomeIcon icon={faTimes} onClick={() => removeAssignee(user)} className='remove-user' /> : <></>}
                    <img src={photo} className="user-img btn btn-secondary dropdown-toggle" type="button" id="reminder-pop-user" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        onClick={() => {
                            setDueDatePopUp(false);
                            setNotifyMePopUp(false);
                            setCloseAssigneePopup(!closeAssigneePopup);
                        }}
                    >
                    </img>
                </div>


            )
        }
    }

    const showPhotoOfUser = (user) => {

        if (user.zuid === null || user.zuid === "") {
            return (
                <div
                    className='no-image-user'
                >{user.first_name ? user.first_name.charAt(0) : ''}</div>)
        }
        else {
            return (<img src={UserService.GetUserPhotoUrl(user.zuid)} className="user-ico" />)
        }
    }

    function disabledDates(current) {
        let date = dayjs(tillDate)
        return current && (current.isBefore(date) || current.isSame(date));
    }
    function disabledDate(current) {
        // Can not select days before today and today
        return current && current < dayjs().add(-1, 'day').endOf('day');
    }

    return (<>
        {loading ? <Loader /> : <></>}
        <div className='w-100 text-left'>
            <h6 style={{
                marginTop: "0",
                marginBottom: "0.5em",
                fontWeight: "600",
                color: "#767676",
            }}>Recurring Event</h6>

            <Row className="Input-Group mb-3">
                <Col>
                    <span className="labeltext">Select Frequency</span>
                    <select disabled={action == "editview" ? true : false} value={repeatObj?.Repeat} onChange={(e) => {
                        let obj = { ...repeatObj }
                        if (e.currentTarget.value == 'Weekly') {
                            obj.WeeklyDay = `${dayjs().format('dddd')}`;
                        }
                        obj.Repeat = e.currentTarget.value;
                        setRepeatObj(obj);
                    }} className='form-control form-control-sm'>
                        <option value="Hourly">Hourly</option>
                        <option value="Daily">Daily</option>
                        <option value="Weekly">Weekly</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Yearly">Yearly</option>
                    </select>
                </Col>
                {/* <Col> */}
                    {/* <span className="labeltext">Time</span> */}
                {repeatObj?.Repeat=="Hourly"?
                    <Col>
                        <span className="labeltext">Time Interval</span>
                        <TimePicker
                            value={dayjs(repeatObj.HourlyInterval)}
                            format="HH:mm"
                            onChange={e => {
                                 
                                let obj = { ...repeatObj }
                                obj.HourlyInterval = dayjs(e.$d).format("MM/DD/YYYY HH:mm");
                                setRepeatObj(obj);
                            }}
                        >
                        </TimePicker>
                    </Col> :
                    <Col>
                        <span className="labeltext">Time</span>
                        <TimePicker
                            value={dayjs(modifyTimezoneString(repeatObj.Time, "MM/DD/YYYY HH:mm"))}
                            format="HH:mm"
                            onChange={e => {
                                let obj = { ...repeatObj }
                                obj.Time = convertToUSTime(e.$d);
                                setRepeatObj(obj);
                            }}
                        >
                        </TimePicker>
                    </Col>
                }
            </Row>
            {getContentByRpeat(repeatObj?.Repeat)}
            <div className='form-group'>
                <div className='row'>
                    <div className='col-6'>
                        <div className="row d-flex align-items-center">
                            <div className="col-4">
                                <span className='mr-2'>Ends</span>
                            </div>
                            <div className="col pl-1">

                                <select disabled={action == "editview" ? true : false} value={repeatObj?.EndBy} onChange={(e) => {
                                    const obj = { ...repeatObj };

                                    obj.EndBy = e.currentTarget.value;
                                    if (e.currentTarget.value == "ByDate") {
                                        obj.EndByValue = dayjs(tillDate).add(1, "months").format('YYYY-MM-DD');
                                    } else if (e.currentTarget.value == "ByCount") {
                                        obj.EndByValue = 1;
                                    }
                                    setRepeatObj(obj);
                                }} className='form-control form-control-sm'>
                                    <option value={'Never'}>Never</option>
                                    <option value={'ByDate'}>By Date</option>
                                    <option value={"ByCount"}>By Count</option>
                                </select>
                            </div>

                        </div>

                    </div>
                    <div className='col-3 p-0'>
                        {repeatObj?.EndBy == "ByCount" ?
                            <input disabled={action == "editview" ? true : false} value={repeatObj?.EndByValue} name='EndByValue' onChange={handleOnChange} type='number' className='form-control form-control-sm' /> :
                            repeatObj?.EndBy == "ByDate" ?
                                <DatePicker
                                    name='EndByValue'
                                    disabled={action == "editview" ? true : false}
                                    format="MM-DD-YYYY"
                                    onChange={(date, dateString) => {
                                        handleOnChange({
                                            currentTarget: {
                                                name: "EndByValue",
                                                value: convertToUSTime(dateString)
                                            }
                                        })
                                    }}
                                    value={dayjs(modifyTimezoneString(repeatObj?.EndByValue,"MM/DD/YYYY HH:mm"))}
                                    disabledDate={disabledDates}
                                />
                                // <input disabled={action == "editview" ? true : false} value={repeatObj?.EndByValue} type='date' name='EndByValue' onChange={handleOnChange} className='form-control form-control-sm' /> 
                                :
                                <></>
                        }
                    </div>
                </div>

            </div>
            <div className='form-group'>
                <div className='row'>
                    <div className='col d-flex align-items-center'>
                        <input style={{ backgroundColor: '#f1cfc5' }} type='text' placeholder={getPlaceholderText()} disabled className='form-control form-control-sm' />
                    </div>
                </div>
            </div>
        </div>
    </>);

}

export default GlobalRecurring;